import { DatePicker,DatePickerProps } from 'antd';
import { FilterCommonInnerProps } from '../../FilterCommon/Filter';
import dayjs, { OpUnitType } from 'dayjs'
export interface DatePickPcProps extends Omit<DatePickerProps,'value'> {
  startDay?:boolean
  endDay?:boolean
  format?: string
  value?: string | dayjs.Dayjs
}

export const DatePickPc = (props: DatePickPcProps) => {
  const { style = {}, startDay,endDay,format = 'YYYY-MM-DD HH:mm:ss',value, ...reset } = props
  let picker = reset.picker || 'day' as any
  return <DatePicker style={{width:'100%',...style}} {...reset} 
    value={value ? dayjs(value) : undefined}
    onChange={(date,dateString)=>{
      if(date){
        if(startDay){
          date = date.startOf(picker)
        }
        if(endDay){
          date = date.endOf(picker)
        }
        dateString = date.format(format)
      }
      props.onChange && props.onChange(date,dateString)
    }}
  />;
};
